import {
  Box,
  type CustomerQuote,
  FormControlSizes,
  HelpIcon,
  HStack,
  IndicatorBadge,
  IndicatorBadgeSizes,
  Text,
} from '@talos/kyoko';
import { useAppStateSelector } from '../../../../providers/AppStateProvider';
import { QuoteCountdown } from '../../../SummaryCard';
import { QuoteActionButtons } from '../components/QuoteActionButtons';
import { useManualRFQPricingContext } from '../ManualRFQPricingContextProvider';

export const PricingPanelBottomActions = ({ quote }: { quote: CustomerQuote }) => {
  const { selectors } = useManualRFQPricingContext();
  const state = useAppStateSelector(selectors.selectState);

  return (
    <HStack justifyContent="space-between" gap="spacing8" background="colors.gray.020" p="spacing8">
      {/* Left side */}
      <Box>
        {quote.EndTime && !quote.isComplete && (
          <>
            <Text>Ends in </Text>
            <QuoteCountdown status={quote.QuoteStatus} endTime={quote.EndTime} />
          </>
        )}
      </Box>

      {/* Right side */}
      <HStack gap="spacing8">
        <IndicatorBadge size={IndicatorBadgeSizes.Large}>
          <HStack gap="spacing2">
            <Box>
              <Text>Currently pricing:</Text>{' '}
              <Text color="colorTextImportant">{`${state.form.pricingMethod === 'composite' ? 'top-down' : 'bottom-up'}`}</Text>
            </Box>

            <HelpIcon tooltip="Shows the form's current pricing method. Top-down means the composite price is used. Bottom-up means the per-leg prices are used." />
          </HStack>
        </IndicatorBadge>
        <QuoteActionButtons size={FormControlSizes.Small} />
      </HStack>
    </HStack>
  );
};
